import { Edit, Translate } from '@mui/icons-material'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './home.css'
import './header.css'
import logo from './img/logo.jpg'
import Translates from './Translate'
import { FaArrowRight, FaDna } from 'react-icons/fa6'

function Header() {

    const [ tr, settr] = useState(false)

    const trs =()=>{
        tr ? settr(false) : settr(true)
    }

    
    const menuClick =()=>{
        const menu_icon = document.querySelector(".menu-icon")
        menu_icon.classList.toggle("open");
        const menu_dropdown = document.querySelector(".menu_dropDown")
        menu_dropdown.classList.toggle("dropDown");
    }

    const navigate = useNavigate()

  return (
    <div className='main_head'>  
    <div className='tophd1' >
        <div className='extrawrt'>
            <small> ▪ Faq </small>
            <small> ▪ Help Desk </small>
            <small> ▪ Track Shipment </small>
            <small> Mon - Sat9 am - 6 pm</small>
        </div>



    </div>
    <div className='header'>
            
        <Link to={'/'} className='desk_header_logo' >
            <img className='desk_header_img' src={logo} alt='/logo' />
            <h3>Allendelivery Courier Company</h3>
        </Link>

        <div className='links'>
        
            <Link to='/' className='link'>
                <h3>HOME</h3>
            </Link>
            <Link to='/about' className='link'>
                <h3>ABOUT US</h3>
            </Link>
            <Link to='/contact' className='link'>
                <h3>CONTACT US</h3>
            </Link>
            <Link to='/FAQs' className='link'>
                <h3>FAQs</h3>
            </Link>

        </div>

            <Translate onClick={trs} style={{marginRight:'1em', cursor:'pointer'}}/>

            <Link to='/request' className='request'>
                <h3>REQUEST A QUOTE</h3>
                <Edit/>
            </Link>
        </div>








        <div className='navbar'>
            <Link to={'/'} className='desk_header_logo' >
                <img className='desk_header_img' src={logo} alt='/logo' />
                <h3>Allendelivery</h3>
            </Link>

            
            <div style={{display:'flex', alignItems:'center'}} >
                <div>
                    <Translate onClick={trs} style={{cursor:'pointer'}}/>
                </div>

                <div onClick={()=>menuClick()} className="menu-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className='menu_dropDown' >
                <div onClick={()=> navigate('/')} className='dropdown_slide'>
                    <p>HOME</p>
                    <FaArrowRight />
                </div>
                <div onClick={()=> navigate('/about')} className='dropdown_slide'>
                    <p>ABOUT US</p>
                    <FaArrowRight />
                </div>
                <div onClick={()=> navigate('/contact')} className='dropdown_slide'>
                    <p>Contact Us</p>
                    <FaArrowRight />
                </div>
                <div onClick={()=> navigate('/FAQs')} className='dropdown_slide'>
                    <p>FAQs</p>
                    <FaArrowRight />
                </div>

                <Link to='/request' className='menu_mobile_logbtn'>
                    <p>REQUEST A QUOTE</p>
                    <FaDna/>
                </Link>
            </div>

            
        </div>

        {
            tr ? 
            <div style={{position:'absolute', bottom:'-4em', right:'1em'}}>
                <Translates/>
            </div>
        :
        null
        }


    </div>
  );
}

export default Header